import { Card, Carousel, ListGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AudioPrompt from './AudioPrompt';

function AudioCarousel({
  carouselIndex,
  tenantPrompts,
  defaultPrompts,
  setPromptError,
  setShowPromptError,
}) {
  return (
    <Carousel
      activeIndex={carouselIndex}
      interval={null}
      indicators={false}
      controls={false}
    >
      {tenantPrompts.map((prompt, promptIdx) => {
        const slideName = `slide-${promptIdx}`;
        return (
          <Carousel.Item key={slideName}>
            <Card>
              <Card.Body>
                <Card.Header>{prompt.name}</Card.Header>
                {prompt.audioInfos?.length > 0 && (
                  <ListGroup>
                    {prompt.audioInfos?.map((audioPrompt, index) => {
                      const audioUrl = audioPrompt.url;
                      const defaultAudioUrl =
                        defaultPrompts[promptIdx].audioInfos[index].url;

                      const audioId = `audio-file-${promptIdx}-${index}`;

                      return (
                        <ListGroup.Item
                          key={audioId}
                          style={{ padding: '10px', border: 0 }}
                        >
                          <AudioPrompt
                            displayName={audioPrompt.name}
                            name={audioId}
                            audioUrl={audioUrl}
                            defaultAudioUrl={defaultAudioUrl}
                            setShowPromptError={setShowPromptError}
                            setPromptError={setPromptError}
                          />
                        </ListGroup.Item>
                      );
                    })}
                  </ListGroup>
                )}
              </Card.Body>
            </Card>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

AudioCarousel.propTypes = {
  carouselIndex: PropTypes.number,
  tenantPrompts: PropTypes.array,
  defaultPrompts: PropTypes.array,
  setPromptError: PropTypes.func,
  setShowPromptError: PropTypes.func,
};

export default AudioCarousel;
